import { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import api from "../../services/api";
import InstituteSidebar from "../../components/admin/InstituteSidebar";
import InstituteNavbar from "../../components/admin/InstituteNavbar";
import { AlertCircle } from "lucide-react";

export default function InstituteLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [subInfo, setSubInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/institute/stats").then(res => {
      if (res.data.subscription_info) {
        setSubInfo(res.data.subscription_info);
      }
    }).catch(() => {});
  }, []);

  let daysRemaining = null;
  if (subInfo?.is_trial && subInfo?.trial_end_date) {
    const end = new Date(subInfo.trial_end_date);
    const now = new Date();
    daysRemaining = Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));
  }

  return (
    <div className="flex min-h-screen overflow-x-hidden bg-slate-50 dark:bg-slate-950">
      <InstituteSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main area - offset for desktop sidebar */}
      <div className="flex min-w-0 flex-1 flex-col lg:ml-64">
        <InstituteNavbar onMenuClick={() => setSidebarOpen(true)} />
        
        {subInfo?.is_trial && daysRemaining !== null && (
          <div className="bg-amber-50 border-b border-amber-200 px-4 py-3 sm:px-6 lg:px-8 flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between shadow-sm z-10 relative">
            <div className="flex items-center gap-3">
              <AlertCircle className="text-amber-600 shrink-0" size={20} />
              <p className="text-sm font-medium text-amber-800">
                Your free trial expires on: <strong>{new Date(subInfo.trial_end_date).toLocaleDateString()}</strong>
                <span className="ml-2 inline-flex items-center rounded-md bg-amber-100 px-2.5 py-0.5 text-xs font-bold text-amber-800 border border-amber-200">
                  {daysRemaining} Days Remaining
                </span>
              </p>
            </div>
            <button onClick={() => navigate("/institute/settings")} className="text-sm font-bold text-amber-800 bg-amber-200 hover:bg-amber-300 px-4 py-1.5 rounded-lg transition-colors border border-amber-300 shadow-sm shrink-0 whitespace-nowrap">
              Upgrade Now
            </button>
          </div>
        )}

        <main className="flex-1 overflow-auto p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
